<template>
    <div class="module-viewer">
        <div v-if="loading" class="module-loading-wrapper">
            <!-- Tablo şeklinde iskelet loading -->
            <a-skeleton :active="true" :paragraph="{ rows: 8 }" title />
        </div>
        <div class="route-page-content" v-else-if="currentModule">
            <SidebarChild :items="menuItems" :focusActive="true" @selected="handleSidebarSelection" />
            <div class="module-page-content" v-if="selectedItem === 'list'">
                <TableDetail
                    :default-table-id="currentModule.table"
                    :moduleMode="true"
                    :pageMode="true"
                    :selected-module="currentModule"
                />
            </div>
        </div>
        <div v-else class="not-found">
            <h3>{{ $t("modulNotFound") || "Modül bulunamadı." }}</h3>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import TableDetail from "../Tables/detail/TableDetail.vue";
import SidebarChild from "../../../components/Sidebar/SidebarChild.vue";
export default Vue.extend({
    name: "ModuleViewer",
    components: {
        SidebarChild,
        TableDetail,
    },
    data() {
        return {
            loading: true,
            currentModule: null,
            selectedItem: "list",
        };
    },
    computed: {
        // Vuex'ten module/getModules getter'ı kullanıyoruz
        ...mapGetters("module", ["getModules"]),
        menuItems() {
            return [
                {
                    enabled: true,
                    key: "list",
                    label: this.currentModule?.displayName || "List",
                    route: `/module/${this.$route.params.moduleName}`,
                    icon: {
                        type: "material-icons",
                        name: "list",
                    },
                },
                {
                    enabled: true,
                    key: "module-settings",
                    label: this.$t("modules.modulesSettings"),
                    route: `/module/${this.$route.params.moduleName}/settings`,
                    icon: {
                        type: "material-icons",
                        name: "settings",
                    },
                },
            ];
        },
    },
    methods: {
        ...mapActions("module", ["syncModules"]),

        /**
         * Router parametresinden gelen moduleName'e göre,
         * store'da bulunan modüller içinden arama yapar.
         */
        findModuleByName(moduleName) {
            for (let i = 0; i < this.getModules.length; i++) {
                const mod = this.getModules[i];
                if (mod.moduleName === moduleName) {
                    return mod;
                }
            }
            return null;
        },
        handleSidebarSelection(item) {
            this.selectedItem = item.key;
            this.$router.push(item.route);
        },

        /**
         * Modülleri senkronize eder ve moduleName'e göre
         * geçerli modülü bulur.
         */
        async loadModule() {
            try {
                this.loading = true;
                // Store'dan modül listesini çekiyoruz
                await this.syncModules();
                // Router parametresindeki moduleName
                const moduleName = this.$route.params.moduleName;
                const foundModule = this.findModuleByName(moduleName);
                if (foundModule) {
                    this.currentModule = foundModule;
                } else {
                    this.$router.push(`/404`);
                }
            } catch (error) {
                console.error("ModuleViewer loadModule error:", error);
            } finally {
                this.loading = false;
            }
        },
    },
    created() {
        this.loadModule();
    },
    watch: {
        /**
         * Parametre (moduleName) değişirse modülü tekrar yükler.
         */
        "$route.params.moduleName"(newVal) {
            this.loadModule();
        },
    },
});
</script>

<style scoped lang="scss">
.module-viewer {
    .module-loading-wrapper {
        padding: 16px;
    }

    .not-found {
        padding: 16px;
        h3 {
            color: #ff4d4f;
        }
    }

    .module-viewer-content {
        display: flex;
        flex-direction: column;
        gap: 10px;
        
    }
    .module-page-content {
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: calc(100% - 60px);
        .title-wrapper {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 10px;
            h3 {
                margin: 0;
            }
        }
        .table-detail {
            width: calc(100% - 0px) !important;
        }
    }
}
</style>
